export default "__VITE_ASSET__B5e6Aivg__"